<template>
  <div class="comp-form-data">
    <jw-spin :loading="loading" class="spin-loading">
      <jw-form :model="form" :disabled="formDisabled" label-align="left" class="task-form" ref="editAddForm" @submit="handleSubmit" scroll-to-first-error>
        <!-- <p>{{data.form}}</p> -->
        <jw-row :gutter="20">
          <template v-for="(modulesItem, index) in form.fieldsList" :key="index">
            <jw-col :span="showColumn === 'single' ? 24 : 12">
              <jw-form-item :rules="rules(modulesItem)" asterisk-position="end" :label-col-style="{ width: '100px' }" label-col-flex="auto" class="form-label-text" :field="`fieldsList.${index}.fieldValue`" :validate-trigger="['blur', 'input', 'change']">
                <template #label>
                  <xl-label-text :value="modulesItem.setting.fieldName" :row="1" />
                  <jw-tooltip v-if="modulesItem?.toast">
                    <icon-question-circle size="18" />
                    <template #content> {{ modulesItem.toast }} </template>
                  </jw-tooltip>
                </template>
                <template v-if="modulesItem.setting.fieldType === 18">
                  <div class="task-upload">
                    <div class="upload-btn">
                      <jw-button type="primary" @click.stop="clickEdit(modulesItem)">点击上传</jw-button>
                    </div>
                    <div style="width: 100%" v-if="modulesItem.fieldValue?.length">
                      <ly-attachment-list :fieldValue="modulesItem.fieldValue" :all="false"></ly-attachment-list>
                    </div>
                  </div>
                </template>
                <template v-else-if="modulesItem.setting.fieldType === 26">
                  <ly-rich-text :fieldValue="modulesItem.fieldValue" :isSingleLine="false" :isTask="true"></ly-rich-text>
                  <p v-if="!formDisabled" class="rich-edit-icon" @click.stop="clickEdit(modulesItem)">
                    <icon-pen-fill />
                  </p>
                </template>
                <!-- 客户中，基础字段，qccid特殊处理 -->
                <template v-else-if="entityId == 2 && modulesItem.setting.type == 1 && modulesItem.setting.fieldType === 0 && modulesItem.setting.fieldKey == 'qccId'">
                  <jw-button @click="correlation(modulesItem)" size="small" type="primary">{{ $t('关联工商信息') }}</jw-button>
                </template>

                <template v-else>
                  <fh-update-fields :modules="modulesItem" :type="30" :disabled-all="formDisabled" :formatData="[{ modules: [modulesItem], type: '10' }]" @cb="updateModulesItem" @selectPopVisibleCb="selectPopVisibleCb" />

                  <!-- <xl-update-fields :formDisabled="formDisabled" :modules="modulesItem" :type="30" :formatData="[{ modules: [modulesItem], type: '10' }]" @cb="updateModulesItem" :isTask="true" @selectPopVisibleCb="selectPopVisibleCb" /> -->
                </template>
              </jw-form-item>
            </jw-col>
          </template>
        </jw-row>
      </jw-form>
    </jw-spin>

    <fh-upload-modal @cb="getNewFieldsVal" ref="uploadRef" opType="0" />
    <ly-editor-dialog ref="editorDialogRef" @cb="handelEditorCb" :isRequired="isRequired"></ly-editor-dialog>

    <!-- <jw-button @click="goSubmit">提交</jw-button> -->
  </div>
  <!-- 关联工商信息 -->
  <xl-business-information ref="informationRef" @cb="getSelectCustomer"></xl-business-information>
</template>

<script setup>
import { ref, computed, provide } from 'vue';
import { Message } from '@arco-design/web-vue';
import { tools } from '@/utils/tools.js';

console.log('1-开始创建组件-setup');

import useViewFields from '@/hooks/view-fields';
import { inject } from 'vue';
import useEditFields from '@/hooks/edit-field';
import useLoading from '@/hooks/loading';

const { getFormFieldValue } = useViewFields();
const { loading, setLoading } = useLoading(false);

const { editField } = useEditFields();
const props = defineProps({
  // 默认值
  fieldsList: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: false
  },
  showColumnNum: {
    type: String,
    default: ''
  }
});
const fieldsLists = computed(() => JSON.parse(JSON.stringify(props.fieldsList)));
const formDisabled = ref(props.disabled);
const showColumn = ref(props.showColumnNum);
const uploadRef = ref(); //上传附件
const editorDialogRef = ref(); //富文本
const isRequired = ref(false);
const detailRefresh = inject('detailParams')?.detailRefresh;
const entityId = inject('detailParams')?.entity;
const drawerRef = document.querySelector('.arco-drawer-body');
const scrollPosition = ref(0);
const handleKey = ref(); // 操作的字段key
const form = ref({
  entity: inject('taskParams').entity,
  fieldKey: undefined,
  businessId: inject('taskParams').businessId,
  fieldValue: undefined,
  fieldsList: JSON.parse(JSON.stringify(fieldsLists.value)),
  customerId: inject('detailParams')?.customerId,
  customerName: inject('detailParams')?.customerName
});
const clickEdit = (record) => {
  const params = {
    entity: form.value.entity,
    businessId: form.value.businessId,
    fieldValue: record.fieldValue,
    fieldExt: record.setting.fieldExt,
    fieldKey: record.value,
    isRequired: record.setting.isRequired
  };
  handleKey.value = record.value;
  if (record.setting.fieldType === 18) {
    uploadRef.value?.openModal(params); //编辑附件弹窗
  }
  if (record.setting.fieldType === 26) {
    isRequired.value = record.setting.isRequired;
    editorDialogRef.value?.openDialog(params);
  }
};
const informationRef = ref(); //客户--关联工商信息
// 点击--关联工商信息
const correlation = (modulesItem) => {
  if (form.value?.customerId && form.value?.customerName) {
    form.value.fieldKey = modulesItem.setting.fieldKey;
    informationRef.value.correlationOpen(form.value?.customerName);
  } else {
    Message.warning('客户名称不能为空！');
  }
};
// 客户关联工商信息回调
const getSelectCustomer = async (qccItem) => {
  // console.log('客户关联工商信息回调', qccItem);
  form.value.fieldValue = qccItem.id;
  const { entity, fieldKey, businessId, fieldValue } = form.value;
  const params = {
    entity,
    fieldKey,
    businessId,
    fieldValue,
    apiIndex: entity + Math.random()
  };
  await editField(params).then((res) => {
    if (!res.error) {
      //编辑成功
      const customerParams = {
        entity,
        businessId,
        fieldKey: 'customerName',
        fieldValue: qccItem.name,
        apiIndex: entity + Math.random()
      };
      editField(customerParams).then((res) => {
        if (!res.error) {
          //编辑成功
          Message.success('保存成功');
          scrollPosition.value = drawerRef.scrollTop;
          detailRefresh?.(drawerRef.scrollTop);
        }
      });
    }
  });
};
const editAddForm = ref();

const rules = (basic) => {
  return {
    required: basic?.setting?.isRequired,
    message: `${basic.setting.fieldName}是必填项`
  };
};

const handleSave = async (params) => {
  await editField(params).then((res) => {
    if (!res.error) {
      //编辑成功
      Message.success('保存成功');
      scrollPosition.value = drawerRef.scrollTop;
      detailRefresh?.(drawerRef.scrollTop);
    } else {
      scrollPosition.value = drawerRef.scrollTop;
      detailRefresh?.(drawerRef.scrollTop);
    }
  });
};

// 富文本回调
const handelEditorCb = async (richValue) => {
  // = val.value;
  // await saveVal();
  const { type, value } = richValue;
  if (type === 'ok') {
    console.log('富文本回调', richValue);
    setLoading(true);
    if (value.length === 0) {
      Message.warning('必填字段不能为空!');
      return;
    }

    const params = {
      entity: form.value.entity,
      businessId: form.value.businessId,
      fieldValue: richValue.value,
      fieldKey: handleKey.value
    };
    await handleSave(params);
  }
};

// 文件上传回调
const getNewFieldsVal = (record) => {
  const { isCancel } = record;
  console.log('上传组件回调', record);
  if (isCancel) {
    return;
  }
  setLoading(true);
  scrollPosition.value = drawerRef.scrollTop;
  detailRefresh?.(drawerRef.scrollTop);
};

const updateSubmit = async (modulesItem) => {
  const resultValue = getFormFieldValue(modulesItem);
  if (!resultValue && modulesItem.setting.isRequired) {
    Message.warning('必填字段不能为空!');
    //   scrollPosition.value = drawerRef.scrollTop;

    // detailRefresh?.(drawerRef.scrollTop);
    return;
  }
  setLoading(true);
  form.value.fieldValue = resultValue;
  form.value.fieldKey = modulesItem.value;
  const { entity, fieldKey, businessId, fieldValue } = form.value;
  console.log('提交数据', entity, fieldKey, businessId, fieldValue);
  const params = {
    entity,
    fieldKey,
    businessId,
    fieldValue,
    apiIndex: entity + Math.random()
  };
  await handleSave(params);
};

//判断值是否相等
const checkIsSameValue = (modulesItem) => {
  const handleField = fieldsLists.value.find((item) => item.value === modulesItem.value);
  if (String(handleField.fieldValue) === String(modulesItem.fieldValue)) {
    return true;
  }
  return false;
};

// 判断是否是下拉多选 或者 多选字段超过5个子字段、人员
const isSelectPopVisible = (modulesItem) => {
  const fieldType = modulesItem?.setting?.fieldType;
  const itemExt = tools.isJSON(modulesItem?.setting?.fieldExt) ? JSON.parse(modulesItem.setting.fieldExt) : [];
  return (fieldType === 3 && itemExt.length > 5) || fieldType === 5 || fieldType === 6;
};

// 选择弹窗回调
const selectPopVisibleCb = async (getformatData, modulesItem) => {
  if (checkIsSameValue(modulesItem)) {
    return;
  }
  await updateSubmit(modulesItem);
};

// 更新字段回调
const updateModulesItem = async (getformatData, modulesItem) => {
  console.log('更新字段回调111', modulesItem);
  if (!isSelectPopVisible(modulesItem)) {
    if (checkIsSameValue(modulesItem)) {
      return;
    }

    const fieldType = modulesItem?.setting?.fieldType;
    const fieldKey = modulesItem?.setting?.fieldKey;
    if (fieldType === 11 && !tools.checkLink(modulesItem.fieldValue)) {
      Message.warning('格式不正确，请以http:// 或 https:// 开头，且不能包含汉字!');
      return;
    }
    const { entity } = form.value;
    if (fieldKey == 'personName' && modulesItem?.setting?.type == 1 && [1, 2, 3].includes(entity)) {
      //联系人且是基础字段
      if (!modulesItem.fieldValue) {
        Message.warning('默认联系人不可清空!');
        const handleField = fieldsLists.value.find((item) => item.value === fieldKey);
        form.value.fieldsList?.forEach((item) => {
          if (item.value === fieldKey) {
            item.fieldValue = handleField.fieldValue;
          }
        });

        return false;
      }
    }

    console.log('操作内容', modulesItem);

    await updateSubmit(modulesItem);
  }
};

const goSubmit = () => {
  editAddForm?.value?.validate();
};

const submitFormData = () => {
  const params = {};
  form.value.fieldsList.forEach((list) => {
    params[list.setting.fieldKey] = getFormFieldValue(list, 2);
  });
  console.log('提交数据', params);
};

const handleSubmit = ({ values, errors }) => {
  console.log('handleSubmit', errors, values);
  if (errors) {
    const errorArray = {};
    Object.values(errors).forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray).forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    const errorMsg = Object.values(errors)?.[0]?.message;
    if (errorMsg) Message.error(errorMsg);
    editAddForm?.value.setFields(errorArray);
    return;
  }
  submitFormData(); //新增/编辑
};

const name = ref();

provide('flow-stage', {
  isTask: true
});

console.log(name);
defineExpose({
  goSubmit,
  editAddForm
});
</script>
<style scoped lang="less">
@import './form-data.less';
</style>
